export default {
  select: 'id,name,description',
  orderBy: 'name',
};
